import TextArea from "antd/es/input/TextArea"
import MyInput from "../../../components/ui/MyInput"
import { Dropdown } from "primereact/dropdown"
import { useEffect, useState } from "react"
import { Input } from "antd"
import { useSelector } from "react-redux"
import PhoneInput from "react-phone-input-2"

const AppDetails = ({ appDetailsFormButtonRef, data, setData, onSave }) => {

    const app = useSelector((state) => state.myAppsSlice?.localReduxData.app);
    const initialAppDetailsData = {
        mobileAppName: app?.mobileAppName,
        subTitle: "",
        keywords: [],
        supportEmail: "",
        promotionalText: "",
        description: "",
        category: categories[0],
        supportPhoneNumber: "",
        copyright: ""
    }
    const [appDetailsData, setAppDetailsData] = useState(initialAppDetailsData)

    const updateAppDetails = (key, value) => {
        setAppDetailsData((state) => ({ ...state, [key]: value }))
    }

    useEffect(() => {

        const newAppDetailsData = { ...initialAppDetailsData }
        Object.keys(data).map(key => {
            if (key in initialAppDetailsData && data[key]) {
                newAppDetailsData[key] = data[key]
            }
        })

        setAppDetailsData(newAppDetailsData)
    }, [])


    return (
        <form className="flex flex-col gap-[20px] items-center p-[20px] "
            onSubmit={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setData(state => ({ ...state, ...appDetailsData }))
                onSave()
            }}
        >
            <div className="w-[1050px] flex flex-row justify-between">
                <div className="w-[500px]">
                    <MyInput value={appDetailsData.mobileAppName} onChange={(e) => (updateAppDetails("mobileAppName", e))} maxLength={30} isLengthActive isRequired={true} label={"Uygulama Adı"} placeholder="Uygulama ismini giriniz." />

                </div>
                <div className="w-[500px]">

                    <MyInput value={appDetailsData.subTitle} onChange={(e) => (updateAppDetails("subTitle", e))} maxLength={30} isLengthActive isRequired={true} label={"Uygulama Alt Metni"} placeholder="Uygulama alt metnini giriniz." />
                </div>

            </div>
            <div className="w-[1050px] flex flex-row justify-between">
                <div className="flex flex-col w-[500px]">

                    <MyInput value={appDetailsData.keywords} onChange={(e) => (updateAppDetails("keywords", e))} className="" maxLength={100} isLengthActive={true} label={"Uygulama Mağaza Anahtar Kelimeleri"} placeholder="alt-üst takım,t-shirt,gömlek,kazak,pantalon" classes={"w-[500px]"} />
                </div>
                <div className="w-[500px]">
                    <MyInput value={appDetailsData.copyright} onChange={(e) => (updateAppDetails("copyright", e))} isRequired={true} label={"Telif Hakkı Metni"} placeholder="Marka İsmi - Tüm Hakları Saklıdır © 2024" />

                </div>
            </div>

            <div className="w-[1050px] flex flex-row justify-between">
                <div className="w-[500px]">

                    <MyInput value={appDetailsData.supportEmail} onChange={(e) => (updateAppDetails("supportEmail", e))} type={"email"} isRequired={true} label={"Destek E-Posta Adresi"} placeholder="E-Posta adresinizi giriniz." classes={"w-[500px]"} />
                </div>
                <div className="w-[500px]">
                    <label
                        className={`block mb-2 text-sm font-medium text-gray-900`}
                    >
                        Destek Telefon Numarası
                    </label>
                    <PhoneInput
                        preferredCountries={['tr', 'de']}
                        inputStyle={{
                            width: '100%',
                            borderWidth: '1px',
                            borderColor: '#D4DBE3',
                            height: '45px',
                            borderRadius: '0.5rem',
                            paddingLeft: '3.5rem',
                        }}
                        inputClass="border-red-500"
                        buttonStyle={{ width: '45px', background: 'white', borderColor: '#D4DBE3', }}
                        buttonClass=""
                        searchClass=""
                        dropdownClass=""
                        country={'tr'}
                        value={appDetailsData.supportPhoneNumber}
                        onChange={phone => updateAppDetails("supportPhoneNumber", phone)}
                    />
                </div>
            </div>
            <div className="w-[1050px] flex flex-row justify-between">

                <div className="flex flex-col w-[500px]">
                    <label
                        className={`block mb-2 text-sm font-medium text-gray-900`}
                    >
                        Uygulama Tanıtım Metni
                    </label>
                    <TextArea value={appDetailsData.promotionalText} onChange={(e) => (updateAppDetails("promotionalText", e.target.value))} required showCount rows={4} maxLength={80} placeholder="App Store ve Play store mağaza açıklama metnini giriniz." classes={"w-[500px]"} />
                </div>
                <div className="flex flex-col w-[500px]">
                    <label
                        className={`block mb-2 text-sm font-medium text-gray-900`}
                    >
                        Uygulama Açıklaması
                    </label>
                    <TextArea value={appDetailsData.description} onChange={(e) => (updateAppDetails("description", e.target.value))} required showCount rows={4} maxLength={4000} placeholder="Uygulamanızın sunduğu hizmetler veya ürünler ile ilgili anahtar kelimeleri giriniz." classes={"w-[500px]"} />
                </div>

            </div>
            <div className="w-[1050px] flex flex-row justify-between">

                <div className="flex flex-col w-[500px]">
                    <label
                        className={`block mb-2 text-sm font-medium text-gray-900`}
                    >
                        Uygulama Kategorisi
                    </label>
                    <Dropdown filter value={appDetailsData.category} required onChange={(e) => { updateAppDetails("category", e.value) }}
                        options={categories} optionLabel="label"
                        className="w-full h-[45px]" />
                </div>

            </div>

            <button className="hidden" ref={appDetailsFormButtonRef} type="submit" ></button>
        </form>
    )
}

export default AppDetails


const categories = [
    {
        "code": "Shopping",
        "label": "Alışveriş"
    },
    {
        "code": "Books",
        "label": "Kitaplar"
    },
    {
        "code": "Business",
        "label": "İş"
    },
    {
        "code": "Developer Tools",
        "label": "Geliştirici Araçları"
    },
    {
        "code": "Education",
        "label": "Eğitim"
    },
    {
        "code": "Entertainment",
        "label": "Eğlence"
    },
    {
        "code": "Finance",
        "label": "Finans"
    },
    {
        "code": "Food & Drink",
        "label": "Yiyecek & İçecek"
    },
    {
        "code": "Games",
        "label": "Oyunlar"
    },
    {
        "code": "Graphics & Design",
        "label": "Grafik & Tasarım"
    },
    {
        "code": "Health & Fitness",
        "label": "Sağlık & Fitness"
    },
    {
        "code": "Lifestyle",
        "label": "Yaşam Tarzı"
    },
    {
        "code": "Magazines & Newspapers",
        "label": "Dergiler & Gazeteler"
    },
    {
        "code": "Medical",
        "label": "Tıp"
    },
    {
        "code": "Music",
        "label": "Müzik"
    },
    {
        "code": "Navigation",
        "label": "Navigasyon"
    },
    {
        "code": "News",
        "label": "Haberler"
    },
    {
        "code": "Photo & Video",
        "label": "Fotoğraf & Video"
    },
    {
        "code": "Productivity",
        "label": "Verimlilik"
    },
    {
        "code": "Reference",
        "label": "Referans"
    },
    {
        "code": "Social Networking",
        "label": "Sosyal Ağlar"
    },
    {
        "code": "Sports",
        "label": "Spor"
    },
    {
        "code": "Stickers",
        "label": "Çıkartmalar"
    },
    {
        "code": "Travel",
        "label": "Seyahat"
    },
    {
        "code": "Utilities",
        "label": "Yardımcı Programlar"
    },
    {
        "code": "Weather",
        "label": "Hava Durumu"
    }
]